export default "__VITE_ASSET__C$b7z8oK__"